import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function defaultValidator(field: CreateSchemaTypes) {
  const maxChars = Number(field.maxCharacters);
  const requiredMessage = 'Dit veld is verplicht';
  const createString = () => {
    const validator = z.string().trim();

    return field.required ? validator.min(1, requiredMessage) : validator;
  };

  const validators = {
    text: createString().max(maxChars || Infinity, `Maximum ${maxChars} karakter toegestaan`),
    email: createString().email('Ongeldig e-mailadres'),
    confirmEmail: createString()
      .email('Ongeldig e-mailadres')
      .refine((value) => value === field.email, 'E-mailadressen komen niet overeen'),
    number: createString().refine(
      (value) => Number(value) >= 0,
      'Negatieve getallen zijn niet toegestaan',
    ),
  };

  let validator =
    validators[field.type === 'String' ? 'text' : field.type] || createString();

  if (field.name === 'confirmEmail') {
    validator = validators.confirmEmail;
  }

  if (field.required) {
    return validator;
  }

  return z.preprocess((value) => (value === '' ? undefined : value), validator.optional().nullable());
}
